module.exports = __webpack_public_path__ + "static/media/ORGANICOS.13f5723d.png";